<template>
  <div>
    <el-row style=" margin-top: 40px; margin-bottom: 80px; height: 120px;">
      <el-col :lg="8" :md="9" :sm="9" :xl="10" :xs="9" class="text-right mb-sm-3">删除历史数据：</el-col>
      <el-col :lg="16" :md="15" :sm="24" :xl="12" :xs="24" class="text-center">
        <el-col :lg="14" :md="14" :sm="14" :xl="12" :xs="15">
          <el-switch
            style="display: block;"
            v-model="deleteHistoricalData.val"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-text="禁用"
            active-text="启用">
          </el-switch>
        </el-col>
        <el-col v-if="deleteHistoricalData.val" :lg="7" :md="10" :sm="7" :xl="7" :xs="7">
          <el-input
            v-model="deleteHistoricalData.time"
            size="mini"
            :max="36"
            @change="checkNumber"
            style="width: 50px;margin-top: -2px;">
          </el-input>&nbsp;&nbsp; 个月
        </el-col>
      </el-col>
      <el-col v-if="deleteHistoricalData.val" class="text-center p-md-3 p-sm-4"
              style="color: rgba(216,228,106,1); font-size: 0.9em;">
        * 该功能启用后，平台将删除{{ deleteHistoricalData.time == '' ? 0 : deleteHistoricalData.time }}个月前的所有测点数据，谨慎选择。
      </el-col>
    </el-row>
    </div>
</template>

<script>
export default {
  name: "editHistoricalData",
  props: ["deleteHistoricalData","editDeleteHistoricalData"],
  data(){
    return{

    }
  },
  created() {

  },
  methods:{
    //数字校验
    checkNumber(){
      if (!this.$checkNumber(this.deleteHistoricalData.time)) {
        this.deleteHistoricalData.time = '';
        this.$message({
          message: '请输入大于0的正整数',
          type: 'warning'
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
